import React, { useEffect, useState } from "react";
import ContactPopUp from "../../ContactPopUp";

function AdobeCampaignBanner() {
  const [background, setBackground] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <section className="section section--banner">
      <div className="container">
        <div className="container__row">
          <div className="container__col-md-6 --section-large-tb-padding">
            <h1 className="container__heading container__heading--platform">
              Adobe Campaign{" "}
            </h1>
            <img
              className="container__logo"
              src="../../solutions/platforms/solution-partner.png"
              alt="Adobe Experience Manager"
            />
            <h2 className="container__sub-heading container__sub-heading--platform">
              Centralized place to create, automate, personalize and orchestrate
              the execution of mobile, social, email, and offline campaigns.{" "}
            </h2>
            <h6 className="container__content">
              Create powerful campaigns by combining our strategy, campaign
              expertise, and experience across various tools/platforms in Adobe
              Experience Cloud.
            </h6>
            <a className="container__link" href="#" onClick={openModal}>
              YOUR FIRST CAMPAIGN IS ON US
            </a>
            <button
              className="button container__button container__button--platform button--green"
              onClick={openModal}
            >
              START FOR FREE!
            </button>
          </div>
          <div className="container__col-md-6 --flex-center">
            <img
              className="container__img --bg-absolute-right"
              src="../../solutions/platforms/adobe-campaign.png"
              alt="Adobe Campaign"
            />
          </div>
        </div>
      </div>

      <ContactPopUp
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        title="Let's Connect"
        subTitle="Fill out this short form, and we'll get back to you within one
        working day."
        section="Adobe-Compaign-Banner"
        page="Adobe-Compaign"
       
      />
    </section>
  );
}

export default AdobeCampaignBanner;
